/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * iPhoneブラウザバック時リロード処理
 */
window.onpageshow = function (evt) {
	if (evt.persisted) {
		location.reload();
	}
};

/**
 * Passive Event Listener.
 */
document.addEventListener("touchstart", function () {}, { passive: true });

/**
 * 表示画面高さ取得
 */
const setFillHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

/**
 * Run.
 */
modules();
smoothscroll.polyfill();

// scroll-hint
import ScrollHint from "scroll-hint";
new ScrollHint(".js-scrollable", {});

/**
 * Clear console.
 */
console.clear();
